import { IRouteGroup } from '../../../../../../interfaces';
import { ROUTE_HEIGHT, ROUTE_MARGIN_TOP, ROUTE_GROUP_HEIGHT, ROUTE_GROUP_MARGIN_TOP } from './constants';

export function getFullHeightOfRouteGroup(routesCount: number): number {
    return routesCount * (ROUTE_HEIGHT + ROUTE_MARGIN_TOP);
}

export function getFullHeightOfRouteGroups(routeGroups: IRouteGroup[] | null): number {
    if (!routeGroups) return 0;
    return (
        routeGroups.length * ROUTE_GROUP_HEIGHT +
        (routeGroups.length - 1) * ROUTE_GROUP_MARGIN_TOP +
        getFullHeightOfRouteGroup(
            routeGroups.reduce((res, routeGroup) => {
                return res + (routeGroup.routes?.length || 0);
            }, 0),
        )
    );
}
